
import { buildPhotoSources } from "@/common/imageUrl";
import OptimizedImage from "./OptimizedImage.vue";

const AVATAR_CONFIGS = {
  "compact-card": {
    width: 320,
    height: 388,
    srcsetSizes: [240, 304, 384, 448, 640, 896],
    getSizes(catalogMinCol) {
      if (catalogMinCol === 1) {
        return "(max-width: 350px) 297px, (max-width: 479px) 426px, (max-width: 767px) 376px, (max-width: 800px) 255px, (max-width: 991px) 303px, 317px";
      } else {
        return "(max-width: 350px) 167px, (max-width: 480px) 209px, (max-width: 767px) 376px, (max-width: 800px) 255px, (max-width: 991px) 303px, 317px";
      }
    },
  },

  "wide-card": {
    width: 264,
    height: 320,
    srcsetSizes: [304, 448, 640, 896],
    getSizes() {
      return "(max-width: 350px) 297px, (max-width: 500px) 447px, 260px";
    },
  },

  review: {
    width: 120,
    height: 145,
    srcsetSizes: [88, 120, 240],
    getSizes() {
      return "(max-width: 768px) 44px, 120px";
    },
  },

  "splash-review": {
    width: 120,
    height: 145,
    srcsetSizes: [120, 240],
    getSizes() {
      return "120px";
    },
  },

  "updates-source": {
    width: 120,
    height: 145,
    srcsetSizes: [88, 120, 240],
    getSizes() {
      return "(max-width: 768px) 44px, 120px";
    },
  },

  "video-item": {
    width: 120,
    height: 145,
    srcsetSizes: [88, 120, 240],
    getSizes() {
      return "(max-width: 768px) 44px, 120px";
    },
  },

  "recently-viewed": {
    width: 120,
    height: 145,
    srcsetSizes: [120, 240],
    getSizes() {
      return "120px";
    },
  },
};

export default {
  name: "Avatar",

  components: {
    OptimizedImage,
  },

  props: {
    src: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: true,
      validator: (value) => Object.keys(AVATAR_CONFIGS).includes(value),
    },
    alt: {
      type: String,
      default: "",
    },
    loading: {
      type: String,
      default: "lazy",
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) => ["default", "rounded", "square"].includes(value),
    },
    pictureClass: {
      type: [String, Object, Array],
      default: "",
    },
  },

  computed: {
    catalogMinCol() {
      return this.$store?.getters?.["catalog/getMinCol"] || 2;
    },

    sizeConfig() {
      return AVATAR_CONFIGS[this.type];
    },

    sources() {
      return buildPhotoSources(this.src, {
        sizes: this.sizeConfig.srcsetSizes,
      });
    },

    computedSizes() {
      return this.sizeConfig.getSizes(this.catalogMinCol);
    },

    avatarClass() {
      return {
        avatar: true,
        "avatar--rounded": this.variant === "rounded",
        "avatar--square": this.variant === "square",
      };
    },
  },
};
